import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { EventCommentData, EventFullData } from "../../types";
import CommentItem from "./item";
import { toast } from "sonner";
import { eventBackend } from "../../services";
import { actions } from "../../state/reducer";
import { generateRandomString } from "../../utils";
import { commentBackend, CommentOutput } from "../../services/comment";

const symbolLimit = 400;

const CommentsList = (props: { comments: CommentOutput[], tab: number, item: number }) => {
  const { comments, tab, item } = props;
  const dispatch = useDispatch();
  const [isPending, setPending] = useState(false);
  const [newComment, setNewComment] = useState("");

  const saveAction = () => {
    if (!newComment) {
      toast("Комментарий не написан");
      return;
    }
    setPending(true);
    commentBackend.addComment({
        tab_id: tab,
        item_id: item,
        comment: newComment
    }).then((res) => {
        if (res) {
            dispatch(actions.selectItem(generateRandomString(4)))
            toast("Комментарий успешно добавлен")
        }
    }).catch((err) => {
        console.log(err)
        toast("Не удалось добавить комментарий")
    }).finally(() => {
        setPending(false); 
    })
  };

  return (
    <div className="commentsContainer">
      <div className="commentsHeader">
        <h2>Комментарии</h2>
      </div>
      <div className="commentsList">
        {comments && comments.length > 0 ? (
          comments.map((item, index) => (
            <CommentItem key={`cmt${index}`} data={item} tab_id={tab} />
          ))
        ) : (
          <div className="noComments">Комментариев пока нет</div>
        )}
      </div>
      <div className="commentForm">
        <div className="w100 columnRight">
        <textarea
          className="commentListInput"
          rows={4}
          placeholder="Введите ваш комментарий..."
          onChange={(event) => {
            const text = event.target.value;
            if (text.length <= symbolLimit) {
              setNewComment(event.target.value)
            } else {
              toast(`Максимальная длина ${symbolLimit} символов`)
            }
          }}
        />
        <div className="limitText">
          {`${newComment.length} / ${symbolLimit}`}
        </div>
        </div>
        <button
          className="btn commentSaveButton"
          type="button"
          disabled={isPending}
          onClick={saveAction}
        >
          Отправить
        </button>
      </div>
    </div>
  );
};

export default CommentsList;
